import { render, staticRenderFns } from "./ContactContent.vue?vue&type=template&id=2c61054e"
import script from "./ContactContent.vue?vue&type=script&lang=js"
export * from "./ContactContent.vue?vue&type=script&lang=js"
import style0 from "./ContactContent.vue?vue&type=style&index=0&id=2c61054e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports